/**
 * Resource that represents an RFID Gate.
 *
 * @name RfidGate
 * @class
 * @augments TmrResource
 */
export const factory = [
  'RfidGate',
  /*@ngInject*/ TmrResource => TmrResource('RfidGate'),
]
